import React from 'react';

const Footer = () => {
    return (
        <div className="footer col-sm-12">
            <footer>
                <p>FOR MORE DETAILS ABOUT OUR GAME OR FOR ANY ENQUIRIES, PLEASE FEEL FREE TO CONTACT US.</p>
                <p> OUR DEDICATED TEAM IS HERE TO ASSIST YOU WITH ANY QUESTIONS YOU MAY HAVE. WE VALUE YOUR FEEDBACK AND ARE COMMITTED TO PROVIDING THE BEST EXPERIENCE POSSIBLE.</p>
                <br></br>
                <p className='email'>YOU CAN REACH US VIA EMAIL AT <a href="mailto:askblinka@gmail.com">BLINKA</a></p>
                <br></br>
                <p>THANK YOU FOR YOUR INTEREST IN OUR GAME. WE LOOK FORWARD TO HEARING FROM YOU!</p>
                <br></br>
                <p>COPYRIGHT &copy; 2024</p>
            </footer>
        </div>
    );
};

export default Footer;
